import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMedal } from '@fortawesome/free-solid-svg-icons';
import BadgeShelf from '../Competitions/BadgeShelf';
import WallOfFame from './WallOfFame';
import './BadgesPage.css';

/* /student/badges and /teacher/badges: my badges & medals + the Wall of fame */
const BadgesPage = ({ mode = 'student' }) => (
  <div className="rmbp">
    <header className="rmbp-head">
      <span className="rmbp-eyebrow">
        <FontAwesomeIcon icon={faMedal} /> Badges & medals
      </span>
      <h1>My badges & medals</h1>
      <p>
        {mode === 'teacher'
          ? 'Earned with your students in the challenges, and given by RoboMind for great teaching. Grey ones are still waiting for you!'
          : 'Earned in the challenges and given by RoboMind for being on time, working hard and making great projects. Grey ones are still waiting for you!'}
      </p>
    </header>

    <div className="rmbp-grid">
      <BadgeShelf path={`/api/${mode}/competitions/badges`} title="My collection" />
      <WallOfFame
        path={`/api/${mode}/awards/feed`}
        max={10}
        empty={
          mode === 'teacher'
            ? 'No badges yet this month. Badges you and your students earn show here for everyone to see.'
            : undefined
        }
      />
    </div>
  </div>
);

export default BadgesPage;
